// Basic Consent Mode: commands queue in dataLayer, gtag.js is only fetched after a grant.
let measurementId: string | null = null;
let scriptLoaded = false;

export function isLocalHost(): boolean {
  const { hostname } = window.location;
  return hostname.includes('localhost') || hostname.includes('127.0.0.1');
}

/** Origin and path plus `utm_*` params — query strings carry tokens and ids, hashes player state. */
export function sanitizeLocation(href = window.location.href): string {
  const url = new URL(href);
  url.search = new URLSearchParams(
    [...url.searchParams].filter(([key]) => key.startsWith('utm_')),
  ).toString();
  url.hash = '';
  return url.toString();
}

export function initGtag(id: string): void {
  if (!id || measurementId != null || isLocalHost()) return;
  measurementId = id;

  window.dataLayer = window.dataLayer ?? [];
  const dataLayer = window.dataLayer;
  // gtag.js only processes `arguments` objects and silently drops arrays
  window.gtag = function gtag() {
    // biome-ignore lint/complexity/noArguments: gtag.js requires the arguments object
    dataLayer.push(arguments);
  } as Gtag.Gtag;

  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });
  window.gtag('set', { page_location: sanitizeLocation() });
  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });
}

export function setGtagConsent(granted: boolean): void {
  if (measurementId == null) return;
  // the official opt-out flag: a loaded gtag.js would otherwise keep sending cookieless pings
  (window as unknown as Record<string, unknown>)[`ga-disable-${measurementId}`] = !granted;
  window.gtag('consent', 'update', { analytics_storage: granted ? 'granted' : 'denied' });
  if (!granted || scriptLoaded) return;

  scriptLoaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}
